// extracted by mini-css-extract-plugin
module.exports = {"single-slide":"SingleSlide_single-slide__JdD2s"};